interface IconProps {
    size?: number;
}

export default function GoogleWorkspaceIcon({ size = 16 }: IconProps) {
    return (
        <svg width={size} height={size} viewBox="0 0 48 48" fill="none">
            <path
                d="M24 9.5C27.54 9.5 30.71 10.72 33.21 13.1L40.06 6.25C35.9 2.38 30.47 0 24 0C14.62 0 6.51 5.38 2.56 13.22L10.54 19.41C12.43 13.72 17.74 9.5 24 9.5Z"
                fill="#EA4335"
            />
            <path
                d="M46.98 24.55C46.98 22.98 46.83 21.46 46.6 20H24V29.02H36.94C36.36 31.98 34.68 34.5 32.16 36.2L39.89 42.2C44.4 38.02 46.98 31.84 46.98 24.55Z"
                fill="#4285F4"
            />
            <path
                d="M10.53 28.59C10.05 27.14 9.77 25.6 9.77 24C9.77 22.4 10.04 20.86 10.53 19.41L2.55 13.22C0.92 16.46 0 20.12 0 24C0 27.88 0.92 31.54 2.56 34.78L10.53 28.59Z"
                fill="#FBBC05"
            />
            <path
                d="M24 48C30.48 48 35.93 45.87 39.89 42.19L32.16 36.19C30.01 37.64 27.24 38.49 24 38.49C17.74 38.49 12.43 34.27 10.53 28.58L2.55 34.77C6.51 42.62 14.62 48 24 48Z"
                fill="#34A853"
            />
        </svg>
    );
}
